import { gql } from '@apollo/client';

export const ADD_LAST_READ_PAGE = gql`
  mutation AddLastReadPage($bookId: Int!, $page: Int!) {
    setLastReadPage(bookId: $bookId, page: $page) {
      last_read_page
    }
  }
`;